
import { AppRoute } from '@/router/routes';
import { Component, Vue } from 'vue-property-decorator';
import { Api } from '@/api';
import { PUBLIC_ROUTES } from '@/constants';
require('vue-image-lightbox/dist/vue-image-lightbox.min.css');
@Component({
  name: 'app',
  components: {},
})
export default class App extends Vue {
  routerReady = false;

  get layout(): string {
    return this.$route.meta?.layout || 'default';
  }

  get isDebugMode(): boolean {
    // tslint:disable-next-line
    return process.env.VUE_APP_DEBUG_MODE == 'true';
  }

  get debugCredentials(): string | undefined {
    return process.env.VUE_APP_DEBUG_CREDENTIALS;
  }

  get isAuthenticated(): boolean {
    return this.$store.getters['auth/isAuthenticated'];
  }

  applyTenant() {
    document.body.classList.add(this.$tenantId);

    if (this.$route.name !== AppRoute.PublicWeddingEvent) {
      document.title = this.$tenant.title;
    }

    // add favicon to html
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.href = `/${this.$tenantId}/favicon-16x16.png`;
    document.head.appendChild(favicon);
  }

  async created() {
    this.$router.onReady(async () => {
      this.applyTenant();

      try {
        // Hydrate session before rendering so auth guards see the user
        const userResponse = await Api.user();
        this.$store.commit('auth/setUser', userResponse.data);
      } catch (e) {
        console.log(this.$route);
        if (!PUBLIC_ROUTES.includes(this.$route.name as AppRoute)) {
          console.log('redirecting to login');
          this.routerReady = true;
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore // @typescript-eslint/ban-ts-ignore
          return this.$router.replace({ name: AppRoute.Login, params: { backToLogin: true } });
        }
      }

      this.routerReady = true;

      if (this.isDebugMode && this.debugCredentials) {
        this.$store.commit('auth/setAuthorization', btoa(this.debugCredentials));
        if (!this.$route.name || this.$route.name === AppRoute.Login) {
          return this.$router.replace({ name: AppRoute.Projects });
        }
      }
    });
  }
}
